<script setup>
/**
 * Adds pull-to-refresh gesture support to a scrollable content area on mobile.
 *
 * @status recommended
 * @group status-feedback
 * @useWhen Letting users pull down to refresh content on a mobile scrollable list
 * @see https://quasar.dev/vue-components/pull-to-refresh Quasar q-pull-to-refresh API
 */
defineOptions({ name: 'HrPullToRefresh' });
</script>

<template>
  <q-pull-to-refresh v-bind="$attrs">
    <!-- @slot Scrollable content area. -->
    <slot />
  </q-pull-to-refresh>
</template>
